var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNotificationError = function SvgNotificationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    fill: "#D0021B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.516 90.507h0l.007-.006c1.803-1.648 2.711-3.716 2.711-6.17 0-2.114-.703-3.962-2.105-5.52-1.648-1.833-3.716-2.758-6.173-2.758-2.116 0-3.965.72-5.522 2.151-1.826 1.641-2.756 3.648-2.756 5.995 0 2.198.715 4.091 2.15 5.652 1.616 1.833 3.656 2.758 6.084 2.758 2.142 0 4.017-.702 5.604-2.102zm-3.61-64.991h-3.895a5.5 5.5 0 00-5.497 5.688l1.152 33.594a5.5 5.5 0 005.497 5.311h1.626a5.5 5.5 0 005.496-5.317l1.118-33.594a5.5 5.5 0 00-5.497-5.682z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round"
  })));
};
export default SvgNotificationError;